import { ActionType, createAction } from "typesafe-actions";

import type { AnalysisConfig } from "@app/component/executiveSummary/types";
import Scope from "@app/types/dashboard/Scope";

export const fetchWeeklySummarySettings = createAction("@dashboard/fetchWeeklySummarySettings")<{
  callback: (config: AnalysisConfig) => void;
  failureCallback?: () => void;
  scope: Scope;
}>();

export const saveWeeklySummarySettings = createAction("@dashboard/saveWeeklySummarySettings")<{
  callback: (config: AnalysisConfig) => void;
  config: AnalysisConfig;
  failureCallback?: () => void;
  scope: Scope;
}>();

export type WeeklySummarySettingsActions = ActionType<
  typeof fetchWeeklySummarySettings | typeof saveWeeklySummarySettings
>;
